









import { Component, Vue, Prop } from 'vue-property-decorator'

export declare interface SelectItem {
  text: string;
  value: string | number;
}

@Component
export default class InputSelect extends Vue {
  @Prop([Array, String, Number]) readonly value!: Array<unknown> | string | number
  @Prop({ default: () => ([]) }) readonly items!: Array<SelectItem>
}
